import { Component, inject } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '@program-suite/ui';
import { ModalLayoutComponent } from '@program-suite/ui';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UI_FORM_IMPORTS } from '../../../ui-form-imports';
export interface ConfirmModalData {
  confirmString: string;
  title?: string;
  subtitle?: string;
  message?: string;
  confirmButtonText?: string;
}

@Component({
  selector: 'lib-confirm-modal',
  standalone: true,
  imports: [
    ModalLayoutComponent,
    ButtonComponent,
    ReactiveFormsModule,
    ...UI_FORM_IMPORTS
],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent {
  data = inject(MAT_DIALOG_DATA) as ConfirmModalData;
  dialogRef = inject(MatDialogRef<ConfirmModalComponent>);
  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      confirmInput: ['', Validators.required]
    });
  }

  onConfirm() {
    const confirmString = this.data.confirmString.toLowerCase();
    const inputValue = this.form.value.confirmInput.toLowerCase();
    if (inputValue === confirmString) {
      this.dialogRef.close(true);
    } else {
      this.form.get('confirmInput')?.setErrors({ message: `Please type ${this.data.confirmString} to Continue` });
    }
  }

  close() {
    this.dialogRef.close(false);
  }
}
